import { render, staticRenderFns } from "./NewsAndEventSection.vue?vue&type=template&id=34553988&"
import script from "./NewsAndEventSection.vue?vue&type=script&lang=ts&"
export * from "./NewsAndEventSection.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports